import React from 'react';

import { observer } from 'mobx-react';

import { BillingPeriodType } from '../../../../../../payment/constants/billingPeriodType';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import { getCurrentUrl, goTo } from '../../../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../../../../payment';
import { SCAN_IQ_PAYMENT_RESULT_TYPE } from '../../../../../../payment/constants/scanIqPaymentResultType';
import { entitySignUpStore } from '../../../../../../shared/stores/entity/entitySignUpStore';
import { CurrentPlanInfo } from '../../../components/CurrentPlanInfo/CurrentPlanInfo';

type CurrentPlanWidgetProps = {
  subscriptionName: string;
  billingPeriodType: BillingPeriodType;
};

const CurrentPlanWidget = observer(
  ({ subscriptionName, billingPeriodType }: CurrentPlanWidgetProps) => {
    const { entityId } = entitySignUpStore;

    const onSubmit = () => {
      const currentUrl = getCurrentUrl();
      goTo('/scaniq-payment-result', {
        params: {
          [pathQueryParams.entityId]: entityId,
          [pathQueryParams.redirectStatus]: 'succeeded',
          [pathQueryParams.retryPath]: currentUrl,
          [pathQueryParams.paymentResultType]:
            SCAN_IQ_PAYMENT_RESULT_TYPE.ALREADY_SUBSCRIBED,
        },
      });
    };

    return (
      <>
        <CurrentPlanInfo
          subscriptionName={subscriptionName}
          billingPeriodType={billingPeriodType}
        />
        <SubmitButton onSubmit={onSubmit} />
      </>
    );
  },
);

export { CurrentPlanWidget };
